import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { initialConfig } from "./helper";
import { useTimerProgress } from "./useTimerProgress";
export function useTimer(userConfig) {
  var config = _objectSpread(_objectSpread({}, initialConfig), userConfig);
  var _useTimerProgress = useTimerProgress(config),
    isRunning = _useTimerProgress.isRunning,
    time = _useTimerProgress.time,
    intervalRef = _useTimerProgress.intervalRef,
    cancelInterval = _useTimerProgress.cancelInterval,
    createInterval = _useTimerProgress.createInterval,
    resetTime = _useTimerProgress.resetTime,
    shouldResetTimeRef = _useTimerProgress.shouldResetTimeRef;
  var pause = function pause() {
    cancelInterval();
  };
  var reset = function reset(newTime) {
    cancelInterval();
    if (newTime) {
      shouldResetTimeRef.current = false;
    }
    resetTime(newTime);
  };
  var start = function start() {
    var _config$onInterval;
    (_config$onInterval = config.onInterval) === null || _config$onInterval === void 0 ? void 0 : _config$onInterval.call(config, time.current);
    if (intervalRef.current) {
      return;
    }
    if (shouldResetTimeRef.current) {
      resetTime();
      shouldResetTimeRef.current = false;
    }
    createInterval();
  };
  return {
    isRunning: isRunning,
    pause: pause,
    reset: reset,
    start: start,
    time: time
  };
}